import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import resolveUrl from '../../../utils/urls/resolve-url';
import * as b from "../../bootstrap.module.css";
import Icon from "../../icon";

const CreditSecondaryContents = ({ active }) => {
  const { calculators } = useStaticQuery(graphql`
    query CreditSecondaryContents {
      calculators: allMysqlTerms(filter: {mysqlId: {in: [256, 260]}}, limit: 2) {
        nodes {
          term
          term_normalized
          path
          menu_icon
        }
      }
    }
  `);

  if (!calculators.nodes.length) {
    return null;
  }

  return (<>
    <strong>Kalkulatory</strong>

    <div className={b.pt1}>
      {calculators.nodes.map((calculator, i) => (
        <Link
          key={i}
          to={resolveUrl(calculator.path, calculator.term_normalized)} 
          className={["top-navigation-link", b.mt2].join(' ')}
        >
          {active && <span className="top-navigation-link-icon">
            <Icon icon={calculator.menu_icon} size={34} />
          </span>}

          {calculator.term}
        </Link>
      ))}
    </div>
  </>);
};

export default CreditSecondaryContents;
